import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@employer-on-record/ui';
import { useAuthStore } from '@/stores/auth';
import Layout from '@/components/layout/Layout';
import LoginPage from '@/pages/LoginPage';
import DashboardPage from '@/pages/DashboardPage';
import CompaniesPage from '@/pages/CompaniesPage';
import CompanyDetailPage from '@/pages/CompanyDetailPage';
import HrUsersPage from '@/pages/HrUsersPage';
import AllRequestsPage from '@/pages/AllRequestsPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
	const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
	const role = useAuthStore((s) => s.user?.role);
	if (!isAuthenticated) return <Navigate to="/login" replace />;
	if (role !== 'super_admin') {
		// Only Canis Major super admins use this app. HR admins and approvers belong to client companies and use apps/web.
		return <Navigate to="/login" replace />;
	}
	return <>{children}</>;
}

export default function App() {
	return (
		<BrowserRouter>
			<Routes>
				<Route path="/login" element={<LoginPage />} />
				<Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
					<Route index element={<DashboardPage />} />
					<Route path="companies" element={<CompaniesPage />} />
					<Route path="companies/:id" element={<CompanyDetailPage />} />
					<Route path="hr-users" element={<HrUsersPage />} />
					<Route path="requests" element={<AllRequestsPage />} />
					<Route path="*" element={<Navigate to="/" replace />} />
				</Route>
			</Routes>
			<Toaster />
		</BrowserRouter>
	);
}
